<template>
  <div>
    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="800px" persistent>
      <template>
        <input
          type="file"
          multiple
          ref="fileInput"
          id="file-input"
          style="display: none"
          @change="handleFileSelect"
          accept=".pdf, .zip"
          
        />
        <div class="custom-empty-modal-wrapper">
          <div class="m-header">
            <div class="title-header">
              <span>{{ $t('components.email.file_upload.preview_attachments') }}</span>
            </div>
          </div>
          <div class="file-upload-dialog-wrapper">
            <div>
              <!-- Drag and Drop Area -->
              <div
                class="drop-zone no-flags"
                @dragover.prevent=""
                @dragleave.prevent
                @drop.prevent="handleDrop"
              >
                <div class="hover-activated">
                  <span>{{ $t('components.email.file_upload.drop_files') }}</span>
                </div>
                <div
                  v-if="
                    fileList.length +
                      fw_file_list.length +
                      attach_file_list.length ==
                    0
                  "
                >
                  <!-- <label for="file-input">Uploadaj</label> -->
                  <label class="drop-area">
                    <div>
                      <div>
                        <svg
                          class="file-input-img"
                          id="Layer_2"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 348.31 305.74"
                        >
                          <g id="Layer_1-2">
                            <path
                              class="cls-1"
                              d="M324.79,150.75c7.11,81.49-62.05,183.4-162.58,147.62-84.24-29.99-210.73-105.88-142.97-154.6C163.88,39.77,72.9,13.19,162.65,15.97c100.81,3.12,152.56,24.91,162.15,134.79Z"
                            />
                            <path
                              class="cls-2"
                              d="M322.97,235.22h-73.51c-.85-.33-1.45-1.15-1.45-2.11,0-1.25,1.01-2.27,2.27-2.27h38.8V89.52c0-12.06-9.78-21.83-21.83-21.83H81.22c-12.06,0-21.83,9.78-21.83,21.83v141.32h30.9c1.25,0,2.26,1.01,2.26,2.27,0,.96-.6,1.78-1.45,2.11H25.49c-3.45,0-6.25,2.8-6.25,6.25s2.8,6.25,6.25,6.25h297.48c3.45,0,6.25-2.8,6.25-6.25s-2.8-6.25-6.25-6.25Z"
                            />
                            <path
                              class="cls-3"
                              d="M224.33,200.46h-100.2c-5.23,0-9.48-3.71-9.48-8.27v-29.68c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v29.68c0,1.77,2.05,3.27,4.48,3.27h100.2c2.43,0,4.48-1.5,4.48-3.27v-29.68c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v29.68c0,4.56-4.25,8.27-9.48,8.27Z"
                            />
                            <path
                              class="cls-3"
                              d="M185.8,184.2h-23.13c-1.38,0-2.5-1.12-2.5-2.5v-38.4l-18.23.05h0c-1.02,0-1.95-.63-2.32-1.58-.38-.95-.13-2.05.62-2.75l32.31-30.26c.96-.9,2.45-.9,3.41,0l32.31,30.09c.75.7,1,1.79.62,2.74-.37.95-1.3,1.58-2.32,1.59l-18.25.05v38.46c0,1.38-1.12,2.5-2.5,2.5ZM165.16,179.19h18.13v-38.45c0-1.38,1.12-2.5,2.49-2.5l14.41-.04-25.97-24.19-25.97,24.32,14.39-.04h0c.66,0,1.3.26,1.77.73.47.47.74,1.11.74,1.77v38.4Z"
                            />
                            <path
                              class="cls-1"
                              d="M324.79,150.75c7.11,81.49-62.05,183.4-162.58,147.62-84.24-29.99-210.73-105.88-142.97-154.6C163.88,39.77,72.9,13.19,162.65,15.97c100.81,3.12,152.56,24.91,162.15,134.79Z"
                            />
                            <path
                              class="cls-4"
                              d="M269.74,50.91c-1.66,0-3-1.34-3-3V3c0-1.66,1.34-3,3-3s3,1.34,3,3v44.91c0,1.66-1.34,3-3,3Z"
                            />
                            <path
                              class="cls-4"
                              d="M345.31,79.56h-44.91c-1.66,0-3-1.34-3-3s1.34-3,3-3h44.91c1.66,0,3,1.34,3,3s-1.34,3-3,3Z"
                            />
                            <path
                              class="cls-4"
                              d="M297.59,48.68c-.69,0-1.39-.24-1.95-.72-1.26-1.08-1.4-2.97-.32-4.23l22.69-26.46c1.08-1.26,2.97-1.4,4.23-.32,1.26,1.08,1.4,2.97.32,4.23l-22.69,26.46c-.59.69-1.43,1.05-2.28,1.05Z"
                            />
                            <path
                              class="cls-4"
                              d="M216.62,44.88c-10.71,0-19.42-8.71-19.42-19.42s8.71-19.42,19.42-19.42,19.42,8.71,19.42,19.42-8.71,19.42-19.42,19.42ZM216.62,12.04c-7.4,0-13.42,6.02-13.42,13.42s6.02,13.42,13.42,13.42,13.42-6.02,13.42-13.42-6.02-13.42-13.42-13.42Z"
                            />
                            <image
                              width="316"
                              height="90"
                              transform="translate(19.09 204.4)"
                              xlink:href="data:image/png;base64,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"
                            />
                            <path
                              class="cls-2"
                              d="M322.97,235.22h-73.51c-.85-.33-1.45-1.15-1.45-2.11,0-1.25,1.01-2.27,2.27-2.27h38.8V89.52c0-12.06-9.78-21.83-21.83-21.83H81.22c-12.06,0-21.83,9.78-21.83,21.83v141.32h30.9c1.25,0,2.26,1.01,2.26,2.27,0,.96-.6,1.78-1.45,2.11H25.49c-3.45,0-6.25,2.8-6.25,6.25s2.8,6.25,6.25,6.25h297.48c3.45,0,6.25-2.8,6.25-6.25s-2.8-6.25-6.25-6.25Z"
                            />
                            <image
                              width="192"
                              height="165"
                              transform="translate(80.09 75.4)"
                              xlink:href="data:image/png;base64,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"
                            />
                            <path
                              class="cls-3"
                              d="M224.33,200.46h-100.2c-5.23,0-9.48-3.71-9.48-8.27v-29.68c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v29.68c0,1.77,2.05,3.27,4.48,3.27h100.2c2.43,0,4.48-1.5,4.48-3.27v-29.68c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v29.68c0,4.56-4.25,8.27-9.48,8.27Z"
                            />
                            <path
                              class="cls-3"
                              d="M185.8,184.2h-23.13c-1.38,0-2.5-1.12-2.5-2.5v-38.4l-18.23.05h0c-1.02,0-1.95-.63-2.32-1.58-.38-.95-.13-2.05.62-2.75l32.31-30.26c.96-.9,2.45-.9,3.41,0l32.31,30.09c.75.7,1,1.79.62,2.74-.37.95-1.3,1.58-2.32,1.59l-18.25.05v38.46c0,1.38-1.12,2.5-2.5,2.5ZM165.16,179.19h18.13v-38.45c0-1.38,1.12-2.5,2.49-2.5l14.41-.04-25.97-24.19-25.97,24.32,14.39-.04h0c.66,0,1.3.26,1.77.73.47.47.74,1.11.74,1.77v38.4Z"
                            />
                          </g>
                        </svg>
                      </div>
                      <p class="instructions">
                        {{ $t("page_2.page_2_3.upload_pop.instruction") }}
                      </p>
                      <div
                        class="standard-rounded-button"
                        @click="triggerFileInput"
                      >
                        {{ $t("page_2.page_2_3.upload_pop.btn_1") }}
                      </div>
                    </div>
                  </label>
                </div>

                <div class="tag-file-main-wrapp" v-else>
                  <div class="odaberi-kategoriju-title">Dodajte privitke ({{cumulateAttachmentSize()}} Mb)</div>

                  <div class="email-imput-file-megawrapp">
                    <div
                      class="file-wrapp-selection"
                      :key="file_list_refresher"
                      @dragover.prevent=""
                      @dragleave.prevent
                      @drop.prevent="handleDrop"
                    >
                      <!-- selected_file_for_tag != index ? 'unselected' : 'selected', -->
                      <div
                        :class="['single-file-wrapp']"
                        v-for="(file, index) in fileList"
                        :key="file.name + index"
                      >
                        <div class="left-side-wrapp">
                          <div :class="['file-icon']">
                            <img :src="getFileIcon(file.name)" />
                          </div>
                          <div>{{ file.name }}</div>
                        </div>
                        <div class="file-action" @click="removeFile(key)">
                          <v-icon>mdi-close</v-icon>
                        </div>
                      </div>
                      <div
                        :class="['single-file-wrapp']"
                        v-for="(file, index) in fw_file_list"
                        :key="file.name + index + 'fw'"
                      >
                        <div class="left-side-wrapp">
                          <div :class="['file-icon']">
                            <img :src="getFileIcon(file.name)" />
                          </div>
                          <div>{{ file.name }}</div>
                        </div>
                        <div class="file-action" @click="removeFWFile(key)">
                          <v-icon>mdi-close</v-icon>
                        </div>
                      </div>
                      <div
                        :class="['single-file-wrapp']"
                        v-for="(file, index) in attach_file_list"
                        :key="file.name + index + 'at'"
                      >
                        <div class="left-side-wrapp">
                          <div :class="['file-icon']">
                            <img :src="getFileIcon(file.name)" />
                          </div>
                          <div>{{ file.name }}</div>
                        </div>
                        <div class="file-action" @click="removeATFile(key)">
                          <v-icon>mdi-close</v-icon>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="error-success-wrapper">
            <div class="error-message" v-if="error_flag">
              Dokumenti: {{ error_files_string }}, imaju grešku prilikom uploada.
            </div>
            <div class="success-message" v-if="success_flag">
              Dokumenti su uspješno uneseni
            </div>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
  
            <div class="button-upload-wrapper">
              <div
                class="button-default button-create"
                :disabled="isUploading || fileList.length === 0"
                @click="uploadFiles"
              >
                {{
                  !isUploading
                    ? $t("page_2.page_2_3.upload_pop.btn_2")
                    : "Učitavam..."
                }}
              </div>
            </div>
          </v-card-actions> -->
            <div class="email-response-activities bottom-act">
              <div class="attachment-button m-btn-wrapp">
                <div
                  class="m-single-btn m-single-prilog"
                  @click="triggerFileInput"
                >
                  {{ $t("page_2.page_2_3.upload_pop.btn_1") }}
                </div>

                <!--dodaj ikonicu-->
                <div
                  @click="openFWFilePicker"
                  class="m-single-btn m-single-prilog"
                >
                  Odaberi iz FW
                </div>

                <!--dodaj ikonicu-->
              </div>
              <div class="right-button-wrapp m-btn-wrapp">
                <div
                  class="m-cancel-btn m-single-btn"
                  @click="openChangedFileStructure()"
                >
                  <svg
                    id="Layer_2"
                    data-name="Layer 2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 42 42"
                  >
                    <g id="Layer_1-2" data-name="Layer 1">
                      <g>
                        <g>
                          <path
                            class="cls-2"
                            d="M30.81,31.46c-.32,0-.64-.12-.88-.37L10.68,11.85c-.49-.49-.49-1.28,0-1.77.49-.49,1.28-.49,1.77,0l19.25,19.25c.49.49.49,1.28,0,1.77-.24.24-.56.37-.88.37Z"
                          />
                          <path
                            class="cls-2"
                            d="M11.56,31.46c-.32,0-.64-.12-.88-.37-.49-.49-.49-1.28,0-1.77L29.92,10.08c.49-.49,1.28-.49,1.77,0,.49.49.49,1.28,0,1.77L12.44,31.1c-.24.24-.56.37-.88.37Z"
                          />
                        </g>
                        <rect class="cls-1" x="0" width="42" height="42" />
                      </g>
                    </g>
                  </svg>
                  Odustani
                </div>
                <!--dodaj ikonicu-->
                <div class="m-save-btn m-single-btn" @click="saveFiles()">
                  <svg
                    id="Layer_2"
                    data-name="Layer 2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 42 42"
                  >
                    <g id="Layer_1-2" data-name="Layer 1">
                      <g>
                        <g>
                          <path
                            class="cls-2"
                            d="M31.52,35.2H11.49c-2.53,0-4.6-2.06-4.6-4.6V10.58c0-2.53,2.06-4.6,4.6-4.6h16.7c.71,0,1.33.29,1.7.81.46.63,1.16,1.51,1.97,2.53,1.07,1.34,2.39,3.01,3.7,4.77.37.5.56,1.02.56,1.55v14.97c0,2.53-2.06,4.6-4.6,4.6ZM11.49,8.48c-1.16,0-2.1.94-2.1,2.1v20.03c0,1.16.94,2.1,2.1,2.1h20.02c1.16,0,2.1-.94,2.1-2.1v-14.95s-.02-.03-.06-.09c-1.28-1.72-2.59-3.37-3.64-4.7-.74-.93-1.39-1.75-1.87-2.39H11.49Z"
                          />
                          <path
                            class="cls-2"
                            d="M25.4,13.23h-7.98c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25h7.98c.69,0,1.25.56,1.25,1.25s-.56,1.25-1.25,1.25Z"
                          />
                          <path
                            class="cls-2"
                            d="M28.33,30.65h-13.44c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25h13.44c.69,0,1.25.56,1.25,1.25s-.56,1.25-1.25,1.25Z"
                          />
                        </g>
                        <rect class="cls-1" x="0" width="42" height="42" />
                      </g>
                    </g>
                  </svg>
                  Pohrani
                </div>
              </div>
            </div>
          </div>
          <action-confirmation-dialog
            ref="filesUploadConfirmation"
            :message="are_you_sure_msg"
            @confirm="closeDialog()"
          />
          <action-invalid-dialog :message="err_msg" ref="file_err_ref"/>
          <firwmide-file-selector
            ref="fwFilePicker"
            @acceptChanges="acceptFwFiles"
          />
        </div>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import $ from "jquery";
import { returnFileTypeImage } from "../../../helpers/file";
import ActionConfirmationDialog from "../../generalComponents/ActionConfirmationDialog.vue";
import FirwmideFileSelector from "../../generalComponents/FileViewer/FirwmideFileSelector.vue";
import ActionInvalidDialog from '../../generalComponents/ActionInvalidDialog.vue';
export default {
  components: { ActionConfirmationDialog, FirwmideFileSelector, ActionInvalidDialog },
  data() {
    return {
      fileList: [],
      dialog: false,

      files_selected: [],
      fw_file_list: [],
      attach_file_list: [],

      snackbar: false,
      snackbarMessage: "",
      isUploading: false,

      file_list_refresher: 1,

      selected_file_for_tag: null,

      success_flag: false,

      error_flag: false,
      error_files_string: "",

      changes_made_to_files: false,
      are_you_sure_msg: "Jeste li sigurni da želite odbaciti sve izmjene?",
      err_msg : "Premašili ste dozvoljenu veličinu privitaka od 20Mb. Molimo uredite svoj popis.",
      outlook_size_limit : 20.00
    };
  },
  watch: {
    fileList: {
      handler: function (new_value) {
        console.log("changes inside", new_value);
        this.changes_made_to_files = true;
      },
      deep: true,
    },
  },
  computed: {
    finalFileList() {
      return this.fileList
        .concat(this.fw_file_list)
        .concat(this.attach_file_list);
    },
  },
  methods: {
    cumulateAttachmentSize() {
      let cumulated_size = (
        this.finalFileList.map((p) => p.size).reduce((a, b) => a + b, 0) *
        0.000001
      ).toFixed(2);
      return cumulated_size;
    },
    acceptFwFiles(files) {
      console.log(files);
      this.fw_file_list = files;
    },
    openFWFilePicker() {
      this.$refs.fwFilePicker.openDialog([...this.fw_file_list]);
    },
    openChangedFileStructure() {
      this.$refs.filesUploadConfirmation.openDialog();
    },
    selectAllFiles() {
      if (this.fileList.length == this.files_selected.length) {
        this.files_selected = [];
      } else {
        this.files_selected = [...this.fileList.map((p) => p.id)];
      }
    },

    openDialog(file_list) {
      console.log("opening it", file_list);
      this.fileList = file_list.local;
      this.fw_file_list = file_list.fw;
      this.attach_file_list = file_list.attached;
      this.dialog = true;
    },
    getFileIcon(filename) {
      return returnFileTypeImage(filename);
    },
    saveFiles() {
      if( parseFloat(this.cumulateAttachmentSize()) <= this.outlook_size_limit)
      {
        this.$emit("fileListLocalUpdate", {
        local_files: this.fileList,
        fw_files: this.fw_file_list,
        attached_files: this.attach_file_list,
      });
      this.closeDialog();
      }else{
        this.$refs.file_err_ref.openDialog();
      }
      
    },
    closeDialog() {
      this.dialog = false;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileSelect(event) {
      const files = Array.from(event.target.files);
      this.addFiles(files);
    },
    handleDrop(event) {
      const files = Array.from(event.dataTransfer.files);
      this.addFiles(files);
    },
    addFiles(files) {
      files.forEach((file) => {
        if (!this.fileList.some((f) => f.name === file.name)) {
          this.fileList.push(file);
        }
      });
    },
    removeFile(index) {
      this.fileList.splice(index, 1);
    },
    removeFWFile(index) {
      this.fw_file_list.splice(index, 1);
    },
    removeATFile(index) {
      this.attach_file_list.splice(index, 1);
    },

    fileClickedEvent(single_file) {
      const file_position = this.files_selected.findIndex(
        (p) => p == single_file.id
      );
      if (file_position == -1) {
        this.files_selected.push(single_file.id);
      } else {
        this.files_selected.splice(file_position, 1);
      }
    },
    //   async uploadFiles() {
    //     this.isUploading = true;
    //     console.log(
    //       "uploading files",
    //       this.fileList,
    //       this.selected_upload_folder,
    //       this.group_id
    //     );
    //     await uploadFiles(
    //       this.group_id,
    //       this.selected_upload_folder,
    //       this.fileList,
    //       this.default_tag,
    //       this.active_tag
    //     ).then(async (resp) => {
    //       console.log("Awaited response from upload", resp);
    //       if (resp.unsuccessfulUploads.length > 0) {
    //         this.error_flag = true;
    //         this.error_files_string = resp.unsuccessfulUploads
    //           .map((p) => p.name)
    //           .join(",");
    //         this.isUploading = false;
    //       } else {
    //         this.success_flag = true;
    //         this.isUploading = false;
    //         this.fileList = [];
    //         this.$emit("refresh");
    //         this.active_tag = this.default_tag;
    //         const filtered_su = resp.successfulUploads.filter(p=> p.tag.id != this.default_tag.id)
    //         await fileTaggingHandler
    //           .upsert(this.group_id, filtered_su, this.default_tag)
    //           .then((response) => {
    //             console.log(response);
    //           });
    //       }
    //       setTimeout(() => {
    //         this.success_flag = false;
    //         this.error_flag = false;
    //       }, 3000);
    //       setTimeout(() => {
    //         this.dialog = false;
    //       }, 1000);
    //     });
    //   },
  },
  async created() {},
  mounted() {},
};
</script>